const BASE_URL = "";
export const TIMEOUT = 10000;
export const SUCCESS_CODE = 20000;
export const FAILED_CODE = 99999;
export default { BASE_URL };
